// @ts-nocheck
import { takeLatest } from 'redux-saga/effects';
import { putAPIDataV2 } from 'utils/api';
import * as sagaActions from './sagaActions';

function* resetTable({ payload }) {
  const { tableId } = payload;
  yield putAPIDataV2(`table/columns/reset/${tableId}`);
}
export {resetTable}

export default function* rootSaga() {
  return [yield takeLatest(sagaActions.reset, resetTable)];
}
